import {
    DialogPositioningBehavior,
    DialogProps,
    DialogType,
    DialogWidget
  } from '@tableau/widgets';
  import React from 'react';

  import { Messages } from '~src/codegen/Localize';
  import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
  import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { KMSKeyActivateView } from '../components/KMSKeyActivateView';


export const openKMSKeyActivatePolicyDialog = (externalKeyId: string, siteSettings: ISiteSettingsForSiteAdmin): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.extractEncryption_KMSKeyActivateDialog_Title(),
              testId: 'kms-key-deactivate-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width500px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, externalKeyId, siteSettings);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, externalKeyId: string, siteSettings: ISiteSettingsForSiteAdmin) {
    return (
      <DialogWidget {...dialogProps}>
        {<KMSKeyActivateView closeDialog={closeAndDismiss} externalKeyId={externalKeyId} siteSettings={siteSettings} />}
      </DialogWidget>
    );
  }